// removed by extract-text-webpack-plugin
module.exports = {"TabsWrapper":"Tabs-module__TabsWrapper__3Iz-f","TabsNavWrapper":"Tabs-module__TabsNavWrapper__2gKyS","TabsNav":"Tabs-module__TabsNav__2J3sU","TabsNavButton":"Tabs-module__TabsNavButton__2qBjl","TabNavSelected":"Tabs-module__TabNavSelected__2lILz","TabsNavDot":"Tabs-module__TabsNavDot__1IFA_","TabsBody":"Tabs-module__TabsBody__20iXc","Tabs":"Tabs-module__Tabs__16Lnj","TabsNavSquared":"Tabs-module__TabsNavSquared__1PKNR","TabsNavButtonSquared":"Tabs-module__TabsNavButtonSquared__2TrnF","TabsNavSquaredSelected":"Tabs-module__TabsNavSquaredSelected__xGQHU","TabText":"Tabs-module__TabText__qmojY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Tabs/Tabs.module.css
// module id = 1801
// module chunks = 31